const sys = {
  path: '/sys',
  name: 'systemFunction',
  icon: 'iconxingzhuangjiehe',
  redirect: '/sys/scheduled',
  component: () => import('@/pages/layout/appMain'),
  children: [
    // 参数设置
    {
      icon: 'el-icon-attract',
      name: 'param',
      path: '/paramsetup',
      component: () => import('@/pages/system/params/paramSetup')
    },
    /** date 2022 03 01 */
    {
      icon: 'el-icon-eleme',
      name: 'resource',
      path: '/resource',
      hidden: true,
      component: () => import('@/pages/system/resource/Resource.vue')
    },
    /**
     * date:2022 03 08
     */
    {
      icon: 'el-icon-data-analysis',
      name: 'probeunit',
      path: '/unitMeasurement',
      hidden: true,
      component: () => import('@/pages/system/probeunit/Measurement.vue')
    },
    /**
     * date:2022 04 22
     * 客户管理
     * author:brian
     */
    {
      icon: 'el-icon-data-analysis',
      name: 'customer',
      path: '/customer',
      hidden: true,
      component: () => import('@/pages/system/customer/Customer.vue')
    },
    /**
     * date:2022 06 06
     * 监测点类型
     * author:brian
     */
    {
      icon: 'el-icon-data-analysis',
      name: 'carrierType',
      path: '/carrierType',
      hidden: true,
      component: () => import('@/pages/system/carriertype/carrierType.vue')
    },
    /**
     * date:2022 06 10
     * 探测设备类型
     * author:brian
     */
    {
      icon: '',
      name: 'deviceType',
      path: '/deviceType',
      hidden: true,
      component: () => import('@/pages/system/deviceType/deviceType.vue')
    },
    /** 在线帮助设置 **/
    {
      icon: '',
      name: 'onlineHelp',
      path: '/online_help',
      component: () => import('@/pages/system/onlineHelp/Index.vue')
    }
  ]
}

export default sys
